import React from "react";

export default function PX_toEM_Converter() {
  return (
    <div className="Keyboard_Shortcuts">
      <h1>Keyboard Shortcuts</h1>
      <p>
        This is the placeholder component for{" "}
        <strong>Keyboard Shortcuts</strong>.
      </p>
      <p>Link: /html/reference/keyboard-shortcuts</p>
    </div>
  );
}
